import { useEffect, useState, useRef } from 'react';
import { Trans } from '@lingui/macro';
import SlideUp from '@components/slide-up';

import './style.scss';

const ReadMore = ({ header, children, className, lines = 2, maxHeightOverflow }) => {
    const [open, setOpen] = useState(false);
    const [isTruncated, setIsTruncated] = useState(false)
    const ref = useRef(null)

    const openContainer = () => {
        setOpen(true);
    }

    const closeContainer = () => {
        setOpen(false);
    }


    useEffect(() => {
        const { offsetHeight, scrollHeight } = ref.current || {};
        if (offsetHeight && scrollHeight && offsetHeight < scrollHeight) {
            setIsTruncated(true);
        } else {
            setIsTruncated(false);
            if (maxHeightOverflow < ref.current.children[0].scrollHeight) {
                setIsTruncated(true);
            }
        }
    }, [ref, maxHeightOverflow, children]);

    return (
        <>
            <div className="read-more">
                <div className={`break-words read-more-text`} ref={ref} style={{ "--line-clamp-length": lines, maxHeight: maxHeightOverflow ? maxHeightOverflow + 'px' : 'none' }}>
                    {children}
                </div>
                {isTruncated && <h6 className='bold' onClick={openContainer}><Trans>Read More</Trans></h6>}
            </div>
            {open && (
                <SlideUp header={header} onClose={closeContainer} defaultOpen={true}>
                    <div className={className}>
                        {children}
                    </div>
                </SlideUp>
            )}
        </>
    )
}

export default ReadMore;